import React from 'react';

export type ResizeHandler = (entries: readonly ResizeObserverEntry[]) => void;

export const useResizeObserver = (container: HTMLElement | null, handler: ResizeHandler): void => {
  React.useEffect((): VoidFunction | void => {
    if (container !== null) {
      const resizeObserver = new ResizeObserver(handler);
      resizeObserver.observe(container);

      return (): void => {
        resizeObserver.disconnect();
      };
    }
  }, [container, handler]);
};
